/*
 * Copyright (C) 2021 Bosch.IO GmbH. All rights reserved.
 */

import { Dict } from '../../types';
import {
    BladeOptions,
    BladeRegistration,
    BladesState,
    DefaultBladeOptions,
    InitialBlade,
    OpenBlade,
} from './types';

export function setRelativeActive(
    state: BladesState,
    setActive: (name: string, active?: boolean) => void,
    delta: number,
): void {
    const activeBlade = getActiveBlade(state);
    const idx = state.indexOf(activeBlade);
    const nextActive = state[idx + delta];
    if (nextActive) {
        setActive(nextActive.name, true);
    }
}

export function getOptions(
    defaults: DefaultBladeOptions,
    options: BladeOptions<unknown>,
    overrides: BladeOptions<unknown>,
): BladeOptions<unknown> {
    const merged: Dict<unknown> = {
        ...defaults,
        ...options,
    };
    for (const [name, val] of Object.entries(overrides)) {
        if (val !== undefined) {
            merged[name] = val;
        }
    }
    return merged;
}

export function getActiveBlade(state: BladesState): OpenBlade | undefined {
    return state.find(b => b.options.active);
}

export function getRegistry<T>(
    initBlades: BladeRegistration<T>[],
): Dict<BladeRegistration<T>> {
    return initBlades.reduce((prev, curr) => {
        prev[curr.name] = curr;
        return prev;
    }, {} as Dict<BladeRegistration<T>>);
}

export function getOpenBlades<T>(
    registry: Record<string, BladeRegistration<T>>,
): Array<InitialBlade> {
    return Object.keys(registry)
        .map(k => registry[k])
        .filter(reg => reg.open)
        .map(reg => ({
            name: reg.name,
            options: reg.defaults,
        }));
}
